<template>
  <div :class="$style['progress']">
    <div v-if="title" :class="$style['progress__title']">
      {{ title }}
    </div>
    <div :class="$style['progress__bar']">
      <div :class="$style['progress__bar__inner']" :style="{'transform': `scaleX(${animated ? animatedWidth : width})`}" />
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  title: {
    type: String,
    default: null
  },
  value: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 199
  },
  animated: {
    type: Boolean,
    default: false
  }
})

// @TODO: Make this work with dynamic value
const animatedWidth = ref(0)

const width = computed(() => {
  return props.value / props.max
})

onMounted(async () => {
  if (props.animated) {
    await nextTick()
    setTimeout(() => {
      animatedWidth.value = width.value
    }, 500)
  }
})
</script>
<style lang="scss" module>
.progress {
  min-width: 6rem;

    &__title {
        color: $grey-dark;
        font-size: $font-size-s;
        margin-bottom: $spacing;
        text-align: center;
    }

    &__bar{
        background-color: $grey-light;
        border-radius: $spacing * 0.5;
        height: $spacing;
        margin-top: $spacing * 0.5;
        overflow: hidden;
        width: 100%;

        &__inner {
          background: $grey;
          border-radius: $spacing;
          height: $spacing;
          will-change: transform;
          transform-origin: 0% 50%;
          transition: transform 2s $transition-easing;
        }
    }
}
</style>
